import { API_HOST_NAME } from '../../env.js';
import { GET_REQUEST } from '@helpers/request.js';

const API_TRAJET_REPORT_PATH = API_HOST_NAME;
const structurePaths = {
  team: {
    common: API_TRAJET_REPORT_PATH + '/lead/team',
  },
  lead: {
    individual: API_TRAJET_REPORT_PATH + '/lead/individual',
    list: API_TRAJET_REPORT_PATH + '/lead/list',
    performance: API_TRAJET_REPORT_PATH + '/lead/performance',
  },
  funnelChart: {
    individual: API_TRAJET_REPORT_PATH + '/lead/individual/chart',
    team: API_TRAJET_REPORT_PATH + '/lead/team/chart',
  },
  leadHistory: {
    common: API_TRAJET_REPORT_PATH + '/lead/:id',
    table: API_TRAJET_REPORT_PATH + '/lead/history/:id',
  },
  lov: {
    list: API_TRAJET_REPORT_PATH + '/lead/lovs',
  },
  kpi: {
    team: API_TRAJET_REPORT_PATH + '/lead/team/kpi',
  },
};

export const getTrajetReportTeamDataService = ({
  monthTime,
  teamCode,
  page,
  size,
}) => {
  const requestObject = {
    monthTime,
    teamCode,
    page,
    size,
  };
  return GET_REQUEST(structurePaths.team.common, requestObject);
};

export const getTrajetReportLeadDataService = ({
  monthTime,
  agentCode,
  teamCode,
  status,
  inputType,
  trafficSource,
  sourceDetail1,
  referrerBankBranchCode,
  groupTitle,
  groupTeam,
  leadId,
  fullName,
  referralName,
  agentAssignedLead,
  phoneNumber,
  leadCriteria,
  page,
  size,
  sort,
  serviceType = 'IND',
}) => {
  const requestObject = {
    monthTime,
    agentCode,
    teamCode,
    status,
    inputType,
    trafficSource,
    sourceDetail1,
    referrerBankBranchCode,
    groupTitle,
    groupTeam,
    leadId,
    fullName,
    referralName,
    agentAssignedLead,
    phoneNumber,
    leadCriteria,
    page,
    size,
    sort,
  };
  const url =
    serviceType === 'IND'
      ? structurePaths.lead.individual
      : structurePaths.lead.list;
  return GET_REQUEST(url, requestObject);
};

export const getTrajetReportFunnelChartDataService = ({
  monthTime,
  teamCode,
  agentCode,
  serviceType = 'IND',
}) => {
  const requestObject = {
    monthTime,
    teamCode,
    agentCode,
  };
  const url =
    serviceType === 'IND'
      ? structurePaths.funnelChart.individual
      : structurePaths.funnelChart.team;
  return GET_REQUEST(url, requestObject);
};

export const getTrajetReportLeadDetailDataService = ({ leadId }) => {
  return GET_REQUEST(
    structurePaths.leadHistory.common.replace(':id', leadId),
    {},
  );
};

export const getTrajetReportLeadHistoryTableDataService = ({
  leadId,
  page,
  size,
  sort,
}) => {
  return GET_REQUEST(structurePaths.leadHistory.table.replace(':id', leadId), {
    page,
    size,
    sort,
  });
};

export const getTrajetReportLOVDataService = () => {
  return GET_REQUEST(structurePaths.lov.list, {});
};

export const getTrajetReportPerformanceService = ({
  monthTime,
  teamCode,
  agentCode,
}) => {
  const requestObject = {
    monthTime,
    teamCode,
    agentCode,
  };
  return GET_REQUEST(structurePaths.lead.performance, requestObject);
};

export const getTrajetReportTeamKpiService = ({ monthTime, teamCode }) => {
  const requestObject = {
    monthTime,
    teamCode,
  };
  return GET_REQUEST(structurePaths.kpi.team, requestObject);
};
